import { render, staticRenderFns } from "./layout-statnew.vue?vue&type=template&id=43f66ebd&scoped=true&"
import script from "./layout-statnew.vue?vue&type=script&lang=js&"
export * from "./layout-statnew.vue?vue&type=script&lang=js&"
import style0 from "./layout-statnew.vue?vue&type=style&index=0&id=43f66ebd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f66ebd",
  null
  
)

export default component.exports